module.exports = __webpack_public_path__ + "img/pot.be5030ca.webp";